const candidateSickDays = {
    firestoreRefType: 'collection',
    firestorePath: 'candidates/{candidateID}/sickDays',
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    moduleName: 'candidate_sickDays',
    statePropName: 'sickdays',
    state: {},
    getters: {
        getSickDays: (state) => {
            return state;
        }
    }
    // the rest of your module here

}
// add userModule as vuex plugin wrapped in vuex-easy-firestore


export default candidateSickDays